export const setPromotionState = () => {};

export const setWeigthFetchingState = () => {};
export const setEpicFetchingState = () => {};

export const getMilestoneTitle = () => ({});
export const getBoardsModalData = () => ({});
